import styled from "styled-components";

export default styled.section`
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 3rem;

  max-width: 520px;
  margin: auto;
`;
